import { router } from '@inertiajs/react'
import { useState } from 'react'

import { Avatar } from '../../../utils/avatar'
import { csrfToken } from '../../../utils/csrfToken'

export default function Show({ manager, direct_reports, unassigned_users }) {
  const [directReports, setDirectReports] = useState(direct_reports || [])
  const [unassignedUsers, setUnassignedUsers] = useState(unassigned_users || [])
  const [selectedUserId, setSelectedUserId] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  async function assign() {
    if (!selectedUserId) return
    setSaving(true)
    setError(null)

    const response = await fetch(`/company_settings/org_chart/${manager.id}/add_direct_report`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken() || '',
      },
      body: new URLSearchParams({ direct_report_id: selectedUserId }),
      credentials: 'same-origin',
    })

    if (!response.ok) {
      setError(`Failed: ${response.status}`)
      setSaving(false)
      return
    }

    const payload = await response.json()
    setDirectReports(payload.direct_reports || [])
    setUnassignedUsers(payload.unassigned_users || [])
    setSelectedUserId('')
    setSaving(false)
  }

  return (
    <>
      <div className="header">
        <img src="/assets/dashkit/covers/profile-cover-1.jpg" className="header-img-top" alt="" />

        <div className="container-fluid">
          <div className="header-body mt-n5 mt-md-n6">
            <div className="row align-items-end">
              <div className="col-auto">
                <div className="avatar avatar-xxl header-avatar-top">
                  <Avatar user={manager} size="xxl" />
                </div>
              </div>

              <div className="col mb-3 ms-n3 ms-md-n2">
                <h6 className="header-pretitle">Human Resources</h6>
                <h1 className="header-title">{manager.full_name || manager.email}</h1>
                <p className="text-body-secondary mb-0">{manager.email}</p>
              </div>

              <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                <button
                  type="button"
                  className="btn btn-white"
                  onClick={() => router.visit('/company_settings/org_chart')}
                >
                  Back to managers
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        {error ? <div className="alert alert-danger">{error}</div> : null}

        <div className="row">
          <div className="col-12 col-md-6 col-xl-4">
            <div className="card">
              <div className="card-header">
                <h4 className="card-header-title">Users without a supervisor</h4>
              </div>

              <div className="card-body">
                {unassignedUsers.length ? (
                  <>
                    <select
                      className="form-select"
                      value={selectedUserId}
                      onChange={(e) => setSelectedUserId(e.target.value)}
                    >
                      <option value="">Select a user</option>
                      {unassignedUsers.map((u) => (
                        <option key={u.id} value={u.id}>
                          {u.full_name || u.email} ({u.email})
                        </option>
                      ))}
                    </select>

                    <button
                      type="button"
                      className="btn btn-primary w-100 mt-3"
                      disabled={!selectedUserId || saving}
                      onClick={assign}
                    >
                      {saving ? 'Assigning…' : `Add to ${(manager.full_name || manager.email)}'s direct reports`}
                    </button>
                  </>
                ) : (
                  <p className="text-body-secondary mb-0">Everyone already has a supervisor.</p>
                )}
              </div>
            </div>
          </div>

          <div className="col">
            <div className="row">
              {directReports.length ? (
                directReports.map((u) => (
                  <div key={u.id} className="col-12 col-md-6 col-xl-4">
                    <div className="card">
                      <img src="/assets/dashkit/covers/profile-cover-2.jpg" alt="" className="card-img-top" />
                      <div className="card-body text-center">
                        <div className="avatar avatar-xl card-avatar card-avatar-top">
                          <Avatar user={u} size="xl" />
                        </div>
                        <h2 className="card-title mb-1">
                          <span className="text-reset">{u.full_name || u.email}</span>
                        </h2>
                        <p className="small text-body-secondary mb-0">{u.email}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h3 className="mb-2">No direct reports yet</h3>
                      <p className="text-body-secondary mb-0">Use the card on the left to add someone.</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  )
}
